// extracted by mini-css-extract-plugin
module.exports = {"primary":"#4073fa","white":"#fff","asideMenuWidth":"150px","headerHeight":"64px"};